var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1c83611946807b56fe6b73c85df54dc0.svg#b';
                    var viewUrl = 'sprites.1c83611946807b56fe6b73c85df54dc0.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };